export default __webpack_public_path__ + "static/media/WhiteBanIcon.e3dd3e16.svg";